
export default class Comparisons
{
    constructor()
    {
        this.setTableCellHeights();
        this.initEventListeners();
    }

    private initEventListeners(): void
    {
        this.initScrollButtonEventListeners();
    }

    private initScrollButtonEventListeners(): void
    {
        const scrollButtons: NodeListOf<HTMLDivElement> = document.querySelectorAll(".sitesmart-ecommerce-comparisons__scroll");
        for (const scrollButton of scrollButtons) {

            scrollButton.addEventListener("click", () => {
                const direction = scrollButton.getAttribute("data-direction");
                let directionAdd = 180;

                if (direction == "left") {
                    directionAdd = -180;
                }

                console.log(directionAdd);

                const comparisonTable: HTMLDivElement|null = document.querySelector(".sitesmart-ecommerce-comparisons__products");

                if (comparisonTable) {

                    let setScroll: number = comparisonTable.scrollLeft + directionAdd;

                    if (setScroll <= 0) {
                        setScroll = 0;
                    }

                    comparisonTable.scrollTo({
                        behavior: "smooth",
                        left: setScroll,
                    });
                }
            });
        }
    }

    private setTableCellHeights(): void
    {
        const rowElements: NodeListOf<HTMLTableRowElement> = document.querySelectorAll("tr.sitesmart-ecommerce-comparison__row");
        const rowHeights: {
            [key: string|number]: number,
        } = {};

        for (const rowElement of rowElements) {

            const rowId = rowElement.getAttribute("data-id");
            const cells = [...rowElement.querySelectorAll("th"), ...rowElement.querySelectorAll("td")];

            if (!rowId) {
                continue;
            }

            if (!rowHeights?.[rowId]) {
                rowHeights[rowId] = 0;
            }

            for (const cell of cells) {
                const r = cell.getBoundingClientRect();
                if (r.height > rowHeights[rowId]) {
                    rowHeights[rowId] = Math.round(r.height);
                }
            }

            for (const cell of cells) {
                cell.style.height = `${rowHeights[rowId]}px`;
            }
        }
    }
}
